// src/App.js

import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// ───────────────── USER PAGES ─────────────────
import Home from "./pages/Home";
import FindDrivers from "./pages/FindDrivers";
import DestinationPage from "./pages/DestinationPage";
import ServicesPage from "./pages/ServicesPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import ContactPage from "./pages/ContactPage";
import RoutePage from "./pages/RoutePage";

import {
  TermsPage,
  PrivacyPage,
  CancellationPage,
} from "./pages/LegalPages";

// ───────────────── ADMIN ─────────────────
import AdminLogin from "./admin/AdminLogin";
import ProtectedRoute from "./admin/ProtectedRoute";
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/Dashboard";
import Drivers from "./admin/Drivers";
import Cabs from "./admin/Cabs";
import Bookings from "./admin/Bookings";
import Users from "./admin/Users";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ───────────────── USER SIDE ───────────────── */}

        {/* Home */}
        <Route path="/" element={<Home />} />

        {/* Main Pages */}
        <Route path="/find-drivers" element={<FindDrivers />} />
        <Route path="/destination" element={<DestinationPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* Legal Pages */}
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cancellation" element={<CancellationPage />} />

        {/* ───────────────── SEO ROUTE PAGES ───────────────── */}
        {/* Dynamic SEO pages from routeData.js */}

        <Route path="/:slug" element={<RoutePage />} />

        {/* Examples:
            /junagadh-to-somnath-cab
            /junagadh-to-dwarka-cab
            /rajkot-airport-taxi
            /ahmedabad-to-gir-cab
        */}

        {/* ───────────────── ADMIN LOGIN ───────────────── */}

        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Redirect /admin → /admin/login */}
        <Route
          path="/admin"
          element={<Navigate to="/admin/login" replace />}
        />

        {/* ───────────────── ADMIN PANEL ───────────────── */}

        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          {/* Default Route */}
          <Route
            index
            element={<Navigate to="dashboard" replace />}
          />

          {/* Admin Pages */}
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="drivers" element={<Drivers />} />
          <Route path="cabs" element={<Cabs />} />
          <Route path="bookings" element={<Bookings />} />
          <Route path="users" element={<Users />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;